import React, { Fragment, useEffect, useState } from "react";
import { SwiperSlide } from "swiper/react";
import { client } from "@/utils/sanity";
import Button from "../ui/Button";
import LogoLoading from "@/components/ui/LogoLoading";
import VideoBanner from "../new/general/VideoBanner";

export default function StoreVideoBanner() {
  const [banners, setBanners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const fetchedBanners = await client.fetch(`*[_type == "nftStoreBanner"]`);
        setBanners(fetchedBanners);
      } catch (error) {
        console.error("Error fetching NFT Store banners:", error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchData();
  }, []);

  const LoadingPlaceholder = () => (
    <div
      className="loading-placeholder-responsive-carousel"
      style={{
        backgroundColor: "transparent",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <LogoLoading />
    </div>
  );

  return (
    <Fragment>
      {isLoading ? (
        <LoadingPlaceholder />
      ) : (
        <VideoBanner
          onSlideChange={(e) => {
            const videos = document.querySelectorAll(".background-video");
            videos.forEach((video, index) => {
              if (index === e.activeIndex) {
                video.play();
              } else {
                video.pause();
              }
            });
          }}>
          {banners.map((banner, index) => (
            <SwiperSlide key={index}>
              <div
                className={`swiperSlideDiv relative w-full transition-transform duration-[600ms] ease-in-out`}>
                {banner.banner && (
                  <video
                    className="background-video object-cover w-full h-full"
                    preload="metadata"
                    poster="/assets/banners/page_banner_aod_thin_grad.png"
                    loop
                    muted
                    autoPlay={true}
                    playsInline
                  >
                    <source src={banner.banner.url} type="video/mp4" />
                  </video>
                )}
                <div className="absolute !pr-8 !pl-8 xl:container inset-x-[8%] 2xl:inset-x-[0%] block pt-4 pb-4 md:pb-24 text-left text-white  top-1/2 transform -translate-y-1/2">
                  <h4 className="text-3xl font-bold text-white text-left leading-tight">
                    {banner.header}
                  </h4>
                  <p className="text-sm text-left md:mt-8 mt-4">
                    {banner.description}
                  </p>
                </div>

                <div
                  className={`!z-[999] md:flex md:inset-x-[8%] !pr-8 !pl-8 xl:container  2xl:inset-x-[0%] w-full md:w-auto absolute bottom-4 md:bottom-16 py-4 md:py-8`}>
                  <a
                    href={
                      banner.buttonLink && banner.buttonLink.url
                        ? banner.buttonLink.url
                        : "#"
                    }
                    target={
                      banner.buttonLink.url === "https://www.metaxseed.io/nodes"
                        ? "_self"
                        : "_blank"
                    }
                    className="flex space-x-4 !z-[999] justify-start items-center rtl:space-x-reverse">
                    <Button
                      icon="iconamoon:arrow-right-6-circle-fill"
                      text={banner.button}
                      className={`!z-[999] hover:jello-horizontal h-min text-md md:w-auto md:min-w-64 w-full md:text-base font-normal text-zinc-50 shadow-lg bg-metaxseed-blue px-8`}
                      iconClassName="text-lg"
                    />
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </VideoBanner>
      )}
    </Fragment>
  );
}
